
import React from 'react';
import './Error.scss'

export default () => (
  <svg viewBox="0 0 17 17" className="error-icon" focusable="false">
    <circle cx="8.5" cy="8.5" r="8.5" />
    <path
      d="M9.78 8.5l2.29-2.29a.9.9 0 1 0-1.28-1.28L8.5 7.22 6.21 4.93a.9.9 0 0 0-1.28
      1.28L7.22 8.5l-2.29 2.29a.9.9 0 0 0 1.28 1.28L8.5 9.78l2.29 2.29a.9.9 0 0 0 1.28-1.28z"
    />
  </svg>
)
